import React, { createContext, createRef, forwardRef, useContext, useState } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from "react-window";
import { PTRowBase } from './PTRow';
import './PTTable.css';

const HeaderContext = createContext();


export const PTTable = ({ items, children, rowSize, row, header, ...props }) => {
    const [rowSizes, setRowSizes] = useState(new Array(items.length + 1).fill(true).reduce((acc, item, i) => {
        acc[i] = rowSize;
        return acc;
    }, {}));

    const [activeRows, setActiveRows] = useState([]);

    const listRef = createRef();

    const getSize = i => {
        return rowSizes[i];
    };

    const ItemWrapper = ({ index, style }) => {
        if (header && index === 0) {
            return null;
        }

        return <PTRowBase index={index} style={style} item={items[index]} row={row} />;
    };

    const innerElementType = forwardRef(({ children, ...rest }, ref) => (
        <HeaderContext.Consumer>
            {() => (
                <div className="pt-table-tbody" ref={ref} {...rest}>
                    {header && header({
                        style: {
                            height: 50
                        }
                    })}
                    {children}
                </div>
            )}
        </HeaderContext.Consumer>
    ));

    return <HeaderContext.Provider value={{ ItemRenderer: children, activeRows, setActiveRows, listRef, rowSize, rowSizes, setRowSizes }}>
        <List ref={listRef}
            className="pt-table"
            itemData={{ ItemRenderer: children }}
            height={props.height || 500}
            width={props.width || 500}
            itemCount={items.length}
            itemSize={getSize}
            innerElementType={innerElementType}
            {...props}
        >
            {ItemWrapper}
        </List>
    </HeaderContext.Provider>
};

export const usePTTable = () => useContext(HeaderContext);

export const PTTableAutoSize = ({ ...rest }) => {
    return <AutoSizer>
        {({ height, width }) => (
            <PTTable height={height} width={width} {...rest} />
        )}
    </AutoSizer >
}


// WEBPACK FOOTER //
// ./src/components/PTTable.js